import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "title", "description", "avatar", "children", "divider", "item", "index", "onKeyDown"];
import React, { useEffect } from "react";
import ClassNames from 'classnames';
import ListContext from "./context/ListContext";
var ListItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    title = props.title,
    description = props.description,
    avatar = props.avatar,
    children = props.children,
    divider = props.divider,
    item = props.item,
    index = props.index,
    onKeyDown = props.onKeyDown,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var listItemRef = React.useRef(null);
  var _React$useContext = React.useContext(ListContext),
    listStore = _React$useContext.listStore,
    listDispatch = _React$useContext.listDispatch;
  var draggable = listStore.draggable;
  useEffect(function () {
    listDispatch({
      type: "updateListItemRefList",
      payload: {
        index: index,
        listItemRef: listItemRef,
        itemKeydownHandler: onKeyDown
      }
    });
  }, [listStore.data]);
  var classes = ClassNames('ap-list-item', className, {
    "ap-draggable": draggable
  });
  var isGrabbed = item && listStore.currentDraggingIndex === item.id;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", _extends({
    ref: listItemRef,
    role: "option",
    className: classes,
    tabIndex: draggable ? -1 : 0,
    "aria-label": "" + (isGrabbed ? "grabbed, use arrow key to rearrange, position " + (Number(index) + 1) : "ungrabbed")
  }, restProps), (avatar || title || description) && /*#__PURE__*/React.createElement("div", {
    className: "ap-list-item-meta"
  }, avatar && /*#__PURE__*/React.createElement("div", {
    className: "ap-list-item-meta-avatar"
  }, avatar), (title || description) && /*#__PURE__*/React.createElement("div", {
    className: "a-list-item-meta-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-list-item-meta-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "ap-list-item-meta-description"
  }, description))), children), divider);
});
export default ListItem;